import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CorService from "./corService"
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function CorList() {

    const [service] = useState(() => new CorService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_cor',
        dsName: 'descricao_cor',
        mainField: { name: 'descricao_cor', label: 'Descrição' },
        advFields: [
            { name: 'codigo_cor', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_cor', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'ativo_cor', label: 'Ativo', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_cor" sortable header="Descrição"></Column>
            <Column field="ativo_cor" sortable header="Ativo" body={e => <InputSwitch checked={e.ativo_cor === 1}></InputSwitch>}></Column>
        </FormList >
    )
}
